(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/co-op-play-marketplace/assets/javascripts/retailer-section.js') >= 0) return;  svs.modules.push('/components/tipsen/co-op-play-marketplace/assets/javascripts/retailer-section.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  useContext
} = React;
const {
  sportProducts
} = svs.components.lbUtils;
const {
  DrawContext
} = svs.components.tipsen.drawProvider;
const {
  ReactButton: Button
} = svs.ui;
const {
  CoOpContext,
  RetailerGameCard,
  RetailerGamePropType
} = svs.components.tipsen;
const {
  Carousel,
  CarouselItem
} = svs.components.lbUi.carousel;
const {
  useMediaQuery,
  breakpoints,
  BREAKPOINT_AM
} = svs.components.lbUtils.useMediaQuery;
const {
  usePrevious
} = svs.components.lbUtils.usePrevious;
const {
  getRetailUrl
} = svs.components.marketplace.helpers;
const {
  trackEvent
} = svs.components.analytics;
const RetailerSection = _ref => {
  let {
    branding,
    retailer
  } = _ref;
  const mobile = useMediaQuery(breakpoints.down(BREAKPOINT_AM)) ? 1 : false;
  const small = useMediaQuery(breakpoints.between(760, 1090)) ? 2 : false;
  const medium = useMediaQuery(breakpoints.between(1090, 1440)) ? 3 : false;
  const large = useMediaQuery(breakpoints.up(1440)) ? 4 : false;
  const itemsPerPage = mobile || small || medium || large;
  const lastPerPage = usePrevious(itemsPerPage);
  const {
    city,
    games,
    id,
    name
  } = retailer;
  const {
    active,
    setActive
  } = useContext(CoOpContext);
  const {
    productId
  } = useContext(DrawContext);
  const product = sportProducts.getProdName(productId);
  let sortedGames = games.sort((game1, game2) => {
    if (game2.currentUserNumberOfShares > game1.currentUserNumberOfShares) {
      return 1;
    }
    if (game2.currentUserNumberOfShares < game1.currentUserNumberOfShares) {
      return -1;
    }

    if (game2.buyStop < game1.buyStop) {
      return 1;
    }
    if (game2.buyStop > game1.buyStop) {
      return -1;
    }
    return 0;
  });
  const selectedIndex = sortedGames.findIndex(game => game.groupId === active.groupId && game.activatedDrawId === active.activatedDrawId);
  const retailerUrl = "".concat(svs.core.urlMapping.get('marketplace')).concat(getRetailUrl(id, name), "?products=").concat(product, "&returnUrl=").concat(location.href);
  const spreadNavDueToHumongousAmountOfGames = itemsPerPage < 3 && games.length > 50;
  const settings = _objectSpread({
    align: mobile ? 'center' : 'start',
    gutter: 1,
    itemsPerPage: itemsPerPage || lastPerPage || 4,
    cardSize: 330
  }, selectedIndex !== -1 ? {
    selectedIndex
  } : {});
  const navMaxPages = 5;
  const maxExceededDesktop = sortedGames.length > settings.itemsPerPage * navMaxPages && !mobile;
  if (maxExceededDesktop) {
    sortedGames = sortedGames.slice(0, settings.itemsPerPage * navMaxPages - 1);
  }
  const displayUserShares = shares => {
    if (shares > 0) {
      return ". Du har ".concat(shares, " ").concat(shares === 1 ? 'andel' : 'andelar');
    }
    return '';
  };
  const shiftFocus = e => {
    const btn = e.target.closest('.skip-link');
    const retailer = e.target.closest('.retailer-section');
    if (btn.dataset.target === 'next-retailer') {
      const sibling = retailer === null || retailer === void 0 ? void 0 : retailer.nextSibling;
      const loadMore = document.querySelector('.co-op-play-marketplace .btn-load-more');
      if (sibling) {
        sibling === null || sibling === void 0 || sibling.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
        sibling === null || sibling === void 0 || sibling.focus();
      } else if (loadMore) {
        loadMore.focus();
      } else {
        const end = e.target.closest('.co-op-play-retail-section-area').querySelector('.skip-end');
        end === null || end === void 0 || end.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
        end === null || end === void 0 || end.focus();
      }
      return;
    }
    const target = document.getElementById(btn.dataset.target);
    target === null || target === void 0 || target.focus();
  };
  const carouselItems = sortedGames.map(game => {
    const {
      activatedDrawId,
      containerId,
      currentUserNumberOfShares,
      name,
      maxFractions
    } = game;
    return React.createElement(CarouselItem, {
      key: "".concat(activatedDrawId, "-").concat(containerId),
      roleDescription: "".concat(name, ", ").concat(maxFractions, " andelar").concat(displayUserShares(currentUserNumberOfShares))
    }, React.createElement(RetailerGameCard, {
      branding: branding,
      game: game,
      onClick: (groupId, activatedDrawId) => setActive({
        groupId,
        activatedDrawId
      })
    }));
  });

  if (maxExceededDesktop) {
    carouselItems.push(React.createElement(CarouselItem, {
      key: "goto-retailer-key",
      roleDescription: "Hoppa till butiken f\xF6r att se fler spel"
    }, React.createElement("div", {
      className: "retailer-more-link"
    }, React.createElement(Button, {
      onClick: () => {
        trackEvent({
          category: 'Andelsspel produktsida',
          action: 'CTA andelsspel',
          opt_label: 'Till butiken'
        });
        window.location = retailerUrl;
      },
      size: 300,
      transparent: true
    }, "Se fler spel p\xE5 butikssidan"))));
  }
  const headerMaxWidth = settings.itemsPerPage * settings.cardSize + (settings.itemsPerPage - 1) * (settings.gutter * 24); 
  const headerAlign = sortedGames.length > settings.itemsPerPage ? 'left' : 'right';
  return React.createElement("section", {
    "aria-label": "Butik ".concat(name).concat(city ? ", ".concat(city) : '', " med ").concat(sortedGames.length, " spel."),
    className: "retailer-section",
    id: "retailer-".concat(id),
    tabIndex: -1
  }, React.createElement("div", {
    className: "retailer-header",
    style: {
      '--header-align': headerAlign,
      '--header-max-width': "".concat(headerMaxWidth, "px"),
      '--header-right': "".concat(settings.cardSize, "px")
    }
  }, React.createElement("div", {
    className: "retailer-info"
  }, React.createElement("h3", {
    className: "retailer-name notranslate"
  }, name), React.createElement("p", {
    className: "retailer-location"
  }, city)), React.createElement("div", {
    className: "retailer-link"
  }, React.createElement(Button, {
    className: "retailer-goto-button",
    onClick: () => {
      trackEvent({
        category: 'Andelsspel produktsida',
        action: 'CTA andelsspel',
        opt_label: 'Till butiken'
      });
      window.location = retailerUrl;
    },
    size: 100,
    transparent: true
  }, "Till butiken")), React.createElement("button", {
    className: "skip-link",
    "data-target": "next-retailer",
    id: "retailer-start-".concat(id),
    onClick: shiftFocus,
    type: "button"
  }, "Hoppa \xF6ver karusell med ".concat(sortedGames.length, " spel."))), React.createElement("div", {
    className: "retailer-content"
  }, React.createElement(Carousel, {
    branding: branding,
    className: spreadNavDueToHumongousAmountOfGames ? 'carousel-nav-spread' : '',
    label: "Spel f\xF6r ".concat(name, ". Lista med ").concat(sortedGames.length, " spel."),
    options: settings
  }, carouselItems)), React.createElement("button", {
    className: "skip-link skip-link-bottom",
    "data-target": "retailer-start-".concat(id),
    id: "retailer-end-".concat(id),
    onClick: shiftFocus,
    type: "button"
  }, "Hoppa till b\xF6rjan av karusell med ".concat(sortedGames.length, " spel.")));
};
RetailerSection.defaultProps = {
  branding: 'sport'
};
setGlobal('svs.components.tipsen.RetailerSection', RetailerSection);

 })(window);